export type OneOrMore<T> = T | T[]
export module OneOrMore {
  export function arrayize<T>(input:OneOrMore<T> | null | undefined) {
    if (input == null) return null

    return Array.isArray(input) ? input : [input]
  }
}

export type Nothing = null | undefined